import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';

import { getOptions } from '@ourbranch/lookups';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import { tooltipHoverTexts } from 'core/helpers/constants';
import { Label } from 'core/components/label';
import useStyles from './fl-umbi.styles';

const FloridaAutoLimits = ({ id, disabled, UMBIOptions }) => {
  const classes = useStyles();

  const workLossOptions = getOptions('policyLimitPIPWL', 'FL').map((opt) => {
    return {
      label: `${opt.value} - ${opt.hint}`,
      value: opt.id,
      id: opt.id
    };
  });

  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Un/Underinsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      <Grid xs={12}>
        <Label type="formSubTitle" className={classes.subTitle}>
          Personal Injury Protection
        </Label>
      </Grid>
      <Grid item xs={6}>
        <LabelTooltip
          label="PIP Deductible"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.pipFloridaLanguage() }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitPIP`}
            id={`${id}.policyLimitPIP`}
            type="select"
            options={getOptions('policyLimitPIP', 'FL')}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>

      <Grid className={classes.workLossCoverage} item xs={12}>
        <LabelTooltip
          label="Work Loss Coverage"
          labelNextToText
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.pipFloridaWL }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitPIPWL`}
            id={`${id}.policyLimitPIPWL`}
            type="radio"
            options={workLossOptions}
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
    </>
  );
};

FloridaAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired
};

FloridaAutoLimits.defaultProps = {
  disabled: false
};

export default connect(FloridaAutoLimits);
